import {useState} from 'react'
import Icon from '../Icon'
import {IconsName} from 'interfaces/IIcons'

import {
  Button
} from './styles'

interface Props {
  variable: "solid" | "outline";
  height: "small" | "big";
  onlyIcon?: boolean;
  children?: React.ReactElement | string;
  leftIcon?: IconsName | React.ReactElement;
  rightIcon?: IconsName;
  style?: object;
  onClick?: (any: any) => any;
  type?: "button" | "submit"
}

export default function ButtonUI({ variable, height, onlyIcon, children, leftIcon, rightIcon, ...props }: Props) {

  let classes = []
  if (variable) classes.push(variable)
  if (height) classes.push(height)
  if (onlyIcon) classes.push('only-icon')

  let IconSetting = {width: '2.2rem', height: '2.2rem', display: 'flex'}

  const [hover, setHover] = useState(false)

  return (
    <Button
      className={classes.join(' ')}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      {...props}
    >
      {/* {leftIcon && <Icon autoplay={hover} playAnimation={hover} style={IconSetting} name={leftIcon} />} */}
      {leftIcon && leftIcon}
      {!onlyIcon && <>{children}</> }
      {rightIcon && <Icon autoplay={hover} playAnimation={hover} style={IconSetting} name={rightIcon} />}
    </Button>
  );
}